export default __webpack_public_path__ + "styles/StatisticalAnalysisResults.7f81512cfd993d5cde51e78400afc0e8.css";